const styles = {
  base: {
    fontFamily: 'Avenir, sans-serif',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    '::placeholder': {
      color: '#84a7c6',
    },
  },
}

const StripePort = {
  add: function(app, publishableKey) {
    if (!window.Stripe) { return; }

    const stripeClient = new Stripe(publishableKey);

    app.ports.stripePortCreateToken.subscribe(function(args) {
      let type = args[0]
      let params = args[1]

      const stripeBankAccount = { country: params.country,
        account_holder_type: params.accountHolderType,
        routing_number: params.routingNumber,
        account_number: params.accountNumber
      };

      stripeClient.createToken(type, { bank_account: stripeBankAccount })
        .then((function(result) {
            app.ports.stripePortCreateTokenResult.send({ token: result.token, error: result.error });
        }));
    });


    let stripeElements = {};

    function restrictAmex(selector, event) {
      const error = event.brand === 'amex' ? 'American Express is not accepted by this practice' : null;

      stripeElements[selector].customError = error;
      app.ports.stripePortCreatePaymentMethodResult.send({ selector: selector, payment_method: null, error: error });
    }

    // Cross browser support
    const requestAnimationFrame = window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.msRequestAnimationFrame;

    const mountAttemptsMax = 20;
    let mountAttempts = 0;

    const makeReady = (selector) => {
      stripeElements[selector].readyElements += 1;
      if (stripeElements[selector].readyElements === 4) {
        app.ports.stripePortBuildAndMountElementResult.send(true);
      }
    }

    function buildAndMountElement(params) {
      const elements = stripeClient.elements();
      const cardNumber = elements.create('cardNumber', { style: styles });
      const cardCvc = elements.create('cardCvc', { style: styles, placeholder: "123" });
      const cardExpiry = elements.create('cardExpiry', { style: styles });
      const postalCode = elements.create('postalCode', { style: styles });

      if (params.options.rejectAmex) {
        cardNumber.on('change', function(event) { restrictAmex(params.selector, event) });
      }

      cardNumber.mount(params.cardNumberSelector);
      cardExpiry.mount(params.cardExpirySelector);
      cardCvc.mount(params.cardCvcSelector);
      postalCode.mount(params.postalCodeSelector);

      cardExpiry.on('ready', () => makeReady(params.selector));
      cardNumber.on('ready', () => makeReady(params.selector));
      cardCvc.on('ready', () => makeReady(params.selector));
      postalCode.on('ready', () => makeReady(params.selector));

      return {
        readyElements: 0,
        elements: elements,
        cardNumber: cardNumber,
        cardCvc: cardCvc,
        cardExpiry: cardExpiry,
        postalCode: postalCode,
        options: params.options,
      };
    }

    function tryBuildAndMountElement(params) {
      const cardElement = document.querySelector(params.selector);

      if (cardElement) {
        requestAnimationFrame(function() {
          stripeElements[params.selector] = buildAndMountElement(params);
        });
      } else {
        if (mountAttempts <= mountAttemptsMax) {
          mountAttempts += 1;
          setTimeout(function() {
            tryBuildAndMountElement(params);
          }, 100)
        }
      }
    }

    app.ports.stripePortBuildAndMountElement.subscribe(tryBuildAndMountElement);

    app.ports.stripePortCreatePaymentMethod.subscribe(function(args) {
      let selector = args[0];
      let type = args[1];
      let params = args[2];

      if (!stripeElements[selector].cardNumber) {
        app.ports.stripePortCreatePaymentMethodResult.send({ selector: selector, payment_method: null, error: 'There must be a card element mounted to create a token.' });
        return;
      }

      if (stripeElements[selector].customError) {
        app.ports.stripePortCreatePaymentMethodResult.send({ selector: selector, payment_method: null, error: stripeElements[selector].customError });
        return;
      }

      stripeClient.createPaymentMethod({ type: type, card: stripeElements[selector].cardNumber, billing_details: params })
        .then(({ error, paymentMethod }) => {
          if (error) {
            app.ports.stripePortCreatePaymentMethodResult.send({ selector: selector, payment_method: null, error: error.message });
          } else {
            app.ports.stripePortCreatePaymentMethodResult.send({ selector: selector, payment_method: paymentMethod, error: null });
          }
        });
    });
  }
}

module.exports = StripePort;
